import { call, select, delay } from 'redux-saga/effects';
import get from 'lodash/get';
import { getGallectionById, getGrusername } from '../selectors';
import { request } from '../../xhr';
import { getGallectionType } from '../helpers';
function* setGallectionDescription(action) {
    yield delay(500); // + takeLatest = debounced
    const { folderId , pointsPrice  } = action.payload;
    const gallection = yield select(getGallectionById, folderId);
    const username = yield select(getGrusername);
    if (!gallection) {
        return;
    }
    var _getGallectionType, _gallection_description;
    const params = {
        username,
        type: (_getGallectionType = getGallectionType(gallection)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        folderid: gallection.folderId,
        name: gallection.name,
        description: (_gallection_description = gallection.description) !== null && _gallection_description !== void 0 ? _gallection_description : undefined,
        cover_deviationid: gallection.type === 'stash' ? undefined : get(gallection, 'thumb.deviationId'),
        points_price: pointsPrice
    };
    yield call(request, {
        method: 'post',
        url: 'gallection/folders/update',
        data: params
    });
}
export default setGallectionDescription;
